import { createAction } from '@reduxjs/toolkit';

export const resetError = createAction('error/resetError');
